import { render, staticRenderFns } from "./DispatchSummarySourceAndDestination.vue?vue&type=template&id=7771fdbc&scoped=true"
import script from "./DispatchSummarySourceAndDestination.vue?vue&type=script&lang=js"
export * from "./DispatchSummarySourceAndDestination.vue?vue&type=script&lang=js"
import style0 from "./DispatchSummarySourceAndDestination.vue?vue&type=style&index=0&id=7771fdbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7771fdbc",
  null
  
)

export default component.exports